
import { Indiamap, International, uuidv4,useNavigate,useState } from '../../common/common';

const MidChooseCountry = () => {
    const navigate = useNavigate();
    const [isLoading, setisLoading] = useState(false);
    const signupCountry = [
        { id: 1, name: "INDIA", countrymap: Indiamap },
        { id: 2, name: "INTERNATIONAL", countrymap: International },
    ];
    const [currentValue, setCurrentValue] = useState(signupCountry[0].id);
    const changeCountry = (country) => {
    
        setCurrentValue(country.id);
        if (country.id === 1) {
            setisLoading(true);
            navigate("/Register/India");
        }
        else if (country.id === 2){
            setisLoading(true);
            navigate("/Register/Other");
        }
    };
    

    return { signupCountry, changeCountry,currentValue,isLoading }
}

export default MidChooseCountry